import { Chip, FlexContainer, Text, useResize } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';

const IsCalculatingBanner = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);
  const { isMobile } = useResize();

  return (
    <FlexContainer direction="column" gap="dimension_08">
      <Chip size="S" type="neutral_line">
        {t('PreviousYear.result.calculating')}
      </Chip>
      {!isMobile && (
        <>
          <Text type="headline" size="S_L_S" color="dark">
            {t('PreviousYearBanner.title')}
          </Text>
          <Text type="paragraphs" size="S_L_L" color="dark">
            {t('PreviousYearBanner.mobile.title')}
          </Text>
        </>
      )}
      <Text type="paragraphs" size="M_L_S" color="dark">
        {t('PreviousYear.result.title_calculating')}
      </Text>
      <Text type="paragraphs" size="XS_M_M" color="grey">
        {t('PreviousYear.result.description_calculating')}
      </Text>
    </FlexContainer>
  );
};

export default IsCalculatingBanner;
